import { Accordion, AccordionDetails, SxProps } from "@mui/material";
import { ReactNode } from "react";

import { VoidFunction } from "../../../models/common.models";
import { ReactService } from "../../../services/react.service";

export enum CollapseAccordionSlots {
  HEADER = "header",
  CONTENT = "content",
}

interface CollapseAccordionProps {
  children: ReactNode[];
  expandedId?: string;
  disableExpand?: boolean;
  id: string;
  handleCollapse: VoidFunction;
  handleClick?: VoidFunction;
  sx?: SxProps;
}

const CollapseAccordion = ({
  children,
  expandedId,
  id,
  handleCollapse,
  handleClick,
  disableExpand,
  sx,
}: CollapseAccordionProps) => {
  return (
    <Accordion
      disableGutters
      expanded={expandedId === id && !disableExpand}
      onClick={() => handleCollapse(expandedId === id ? null : id)}
      sx={{
        ...sx,
        "&:before": { display: "none" },
        background: "transparent",
        margin: "0",
        boxShadow: "none",
        cursor: "pointer",
      }}
    >
      {ReactService.renderSlot(children, CollapseAccordionSlots.HEADER)}

      {
        <AccordionDetails
          onClick={handleClick}
          sx={{
            margin: "0",
            paddingBlock: "0",
            paddingInlineEnd: "0",
            paddingInlineStart: "20px",
          }}
        >
          {ReactService.renderSlot(children, CollapseAccordionSlots.CONTENT)}
        </AccordionDetails>
      }
    </Accordion>
  );
};

export default CollapseAccordion;
